import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum, IsDurationString } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
export class ReadExpirationPolicyDto {
}
__decorate([
    ApiProperty({ type: () => String, example: 'P2DT12H30M15S' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.PUT, DefaultExposeGroupEnum.CREATE] }),
    IsDurationString(undefined, { always: true }),
    __metadata("design:type", String)
], ReadExpirationPolicyDto.prototype, "expirationDuration", void 0);
//# sourceMappingURL=ReadExpirationPolicyDto.js.map